import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgTiktokRegularIcon = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 31 31",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "#000",
		d: "M16 4.5h3.5a6 6 0 0 0 1.6 3.7A6 6 0 0 0 25 9.8v3.7a10 10 0 0 1-3.8-1l-1.4-.8v8a7 7 0 0 1-1.3 3.5 7 7 0 0 1-5.3 2.9 7 7 0 0 1-3.7-1q-2.8-1.7-3.2-5v-1.4a7 7 0 0 1 6.7-6.1h1.2l-.1 4a3 3 0 0 0-4 2V20a3 3 0 0 0 3 2.6 3 3 0 0 0 2.6-1.4q.3-.4.3-1l.1-4.8z"
	})
});
export default SvgTiktokRegularIcon;
